import PropTypes from "prop-types";
import React, { Component } from "react";

import ChatActions from "../../../actions/ChatActions";
import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";
import { possessive } from "../../../utils/Utils";
import i18next from "../../../utils/i18next";

class AddTestimonialSystemMessage extends Component {
    constructor() {
        super();

        this.onToggleTestimonialForm = this.onToggleTestimonialForm.bind(this);
        this.onToggleTestimonialFormKeyPress = this.onToggleTestimonialFormKeyPress.bind(this);
    }

    onToggleTestimonialForm(event) {
        ChatActions.responseToggleTestimonialForm();
        event.preventDefault();
    }

    onToggleTestimonialFormKeyPress(event) {
        if (event.charCode === 32 || event.charCode === 13) {
            this.onToggleTestimonialForm(event);
        }
    }

    render() {
        const { recognitionRecipient } = this.props.response;
        const recognitionRecipientName =
            i18next.language === "en" ? possessive(recognitionRecipient.name) : recognitionRecipient.name;

        return (
            <li className="system-message message-testimonial-prompt">
                <div className="icon icon-primary icon-pencil">
                    <SvgIcon src={iconSprite} id="icon-pencil" />
                </div>
                <p className="body">
                    <span
                        dangerouslySetInnerHTML={{
                            __html: i18n.t("rtm.text.happy_with_answer", {
                                recognitionRecipientName,
                            }),
                        }}
                    />
                    <br />
                    <a
                        onClick={this.onToggleTestimonialForm}
                        onKeyPress={this.onToggleTestimonialFormKeyPress}
                        tabIndex={0}
                    >
                        <strong>{i18n.t("rtm.text.write_a_testimonial")}</strong>
                    </a>
                    .
                </p>
            </li>
        );
    }
}

AddTestimonialSystemMessage.propTypes = {
    response: PropTypes.object.isRequired,
};

export default AddTestimonialSystemMessage;
